import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Page} from '@shared/models/page';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})

export class PaginationComponent {

  @Input()
  public page: Page;

  @Input()
  public totalElements: number;

  @Input()
  public singularLabel: string;

  @Input()
  public pluralLabel: string;

  @Output()
  public changePage = new EventEmitter<number>();

  public paginate(event: {page: number}): void {
    this.changePage.emit(event.page - 1);
  }
}
